__turbopack_context__.v({
  "cancelDownload": "Download-module-scss-module__ohnHOG__cancelDownload",
  "download": "Download-module-scss-module__ohnHOG__download",
});
